module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/resources/font-awesome/fonts/fontawesome-webfont.eot
// module id = ../../../../../resources/font-awesome/fonts/fontawesome-webfont.eot
// module chunks = 2